import styled from "styled-components";

const Title = styled.p`
  font-size: 2.5rem;
  font-weight: bold;
  margin: 1rem 0;
`;

export default Title;
